/* @ts-ignore */
import * as Types from '../../../graphql/generated/graphql.g';

import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';

function fetcher<TData, TVariables>(query: string, variables?: TVariables) {
  return async (): Promise<TData> => {
    const res = await fetch(import.meta.env.VITE_API_URL_GRAPHQL as string, {
    method: "POST",
    ...({"credentials":"include","headers":{"Content-Type":"application/json"}}),
      body: JSON.stringify({ query, variables }),
    });

    const json = await res.json();

    if (json.errors) {
      const { message } = json.errors[0];

      throw new Error(message);
    }

    return json.data;
  }
}
export type ClientApplicationTabsDataQueryVariables = Types.Exact<{
  clientApplicationId: Types.Scalars['UUID']['input'];
}>;


export type ClientApplicationTabsDataQuery = { __typename: 'Query', resourceGroupNotifications?: { __typename: 'NotificationTypeConnection', totalCount?: number | null } | null };



export const ClientApplicationTabsDataDocument = `
    query ClientApplicationTabsData($clientApplicationId: UUID!) {
  resourceGroupNotifications(
    clientApplicationId: $clientApplicationId
    first: 0
    includeResolved: false
  ) {
    totalCount
  }
}
    `;

export const useClientApplicationTabsDataQuery = <
      TData = ClientApplicationTabsDataQuery,
      TError = unknown
    >(
      variables: ClientApplicationTabsDataQueryVariables,
      options?: Omit<UseQueryOptions<ClientApplicationTabsDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ClientApplicationTabsDataQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ClientApplicationTabsDataQuery, TError, TData>(
      {
    queryKey: ['ClientApplicationTabsData', variables],
    queryFn: fetcher<ClientApplicationTabsDataQuery, ClientApplicationTabsDataQueryVariables>(ClientApplicationTabsDataDocument, variables),
    ...options
  }
    )};

useClientApplicationTabsDataQuery.getKey = (variables: ClientApplicationTabsDataQueryVariables) => ['ClientApplicationTabsData', variables];

export const useInfiniteClientApplicationTabsDataQuery = <
      TData = InfiniteData<ClientApplicationTabsDataQuery>,
      TError = unknown
    >(
      variables: ClientApplicationTabsDataQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ClientApplicationTabsDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ClientApplicationTabsDataQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ClientApplicationTabsDataQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ClientApplicationTabsData.infinite', variables],
      queryFn: (metaData) => fetcher<ClientApplicationTabsDataQuery, ClientApplicationTabsDataQueryVariables>(ClientApplicationTabsDataDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteClientApplicationTabsDataQuery.getKey = (variables: ClientApplicationTabsDataQueryVariables) => ['ClientApplicationTabsData.infinite', variables];


useClientApplicationTabsDataQuery.fetcher = (variables: ClientApplicationTabsDataQueryVariables) => fetcher<ClientApplicationTabsDataQuery, ClientApplicationTabsDataQueryVariables>(ClientApplicationTabsDataDocument, variables);
